export default __webpack_public_path__ + "static/media/vinyl_purple.1ddbc416.svg";